jQuery( document ).ready( function( $ ) {

    /**
     * Add class to navbar-toggler when clicked
     */
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('open');
    });


    /**
     * Core Values Grid Box height
     */
    $('.core-value-container').matchHeight({byRow: false,});
    $('.about-grid-image').matchHeight(); 

    /**
     * Bradford Innovation section content height
     */     
    //$('.innovation-content').matchHeight({byRow: true, property: 'height',});  


    /**
     * Stanless Steel video player
     */
    $('.stainless-video').click(function() {
      var video_first = $(this).get(0);

      if ( video_first.paused ) {
          video_first.play();
          $('.video-play-button').hide();
      } else {
          video_first.pause();
          $('.video-play-button').show();
      }

      return false;
    });
    $('.video-play-button').click(function() {
      var video = $('.stainless-video').get(0);

      if ( video.paused ) {
          video.play();
          $(this).hide();
      } else {
          video.pause();
          $(this).show();
      }

      return false;
    });    


    /**
     * Signature Spa configurator image click functionality
     */
     // on load, find the first image, check the data-attribute and use that url to populate the background image
    var starting_spa_img_src = $('.signature-spa-options .tab-pane.active img').first().attr('data-large-image-url');
    $('#spa-display-img').css("background-image", "url(" + starting_spa_img_src + ")");

     // on load, find the first image, check the alt attribute (title) and use that to populate the title with id of #spa-type-title
    var starting_filename = $('.signature-spa-options .tab-pane.active img').first().attr('alt');
    $('#spa-type-title').html(starting_filename);

    /*$('.signature-spa-options a[data-toggle="tab"]').on('click', function() {              
 
    });*/
         
    $('.signature-spa-options img').on('click', function() {
      // find the first img with a 'selected' class, remove it, and add class to the clicked img
      $('.signature-spa-options').find('.selected').removeClass('selected');
      $(this).addClass('selected');

      // get this img data-attribute and use that url to populate the background image
      var click_spa_img_src = $(this).attr('data-large-image-url');
      var click_spa_trim_img_src = $(this).attr('data-trim-image-url');

      // If image has a trim photo, set up full/trim toggle tabs and show them
      if ( (click_spa_trim_img_src === undefined ) || (click_spa_trim_img_src === '') ) {
      	$('#spa-display-img').css("background-image", "url(" + click_spa_img_src + ")");
      	$('.spa-display-img-toggle').hide();
      } else {
      	$('#spa-display-img').css("background-image", "url(" + click_spa_trim_img_src + ")");
      	$('.spa-display-img-toggle a.full-img').attr('data-background', click_spa_img_src).removeClass('active');
      	$('.spa-display-img-toggle a.trim-img').attr('data-background', click_spa_trim_img_src).addClass('active');
      	$('.spa-display-img-toggle').show();
      }

      // get this img alt attribute (title) and use that to populate the title with id of #spa-type-title
      var click_filename = $(this).attr('alt');
      $('.tab-pane.active #spa-type-title').html(click_filename);
      //console.log(click_filename);
    });

    // Full/Trim tab toggle
    $('.spa-display-img-toggle a').on("click", function(e) {
    	e.preventDefault();
    	if (!$(this).hasClass('active')) {
    		$('.spa-display-img-toggle a').removeClass('active');
    		$(this).addClass('active');
    		var background = $(this).attr('data-background');
        //console.log(background);
    		$('#spa-display-img').css("background-image", "url('" + background + "')");
    	}
    });

    $('.signature-spa-options a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
		//console.log('tab change');
		// bootstrap documentation: this event fires on tab show -> after a tab has been shown

		// Hide Full/Trim toggle because first tab click shows "Stainless Steel" which have no trim option
		$('.spa-display-img-toggle').hide();

		// find anything with a 'selected' class (img), remove it, and add it to the first image of the active tab pane
		$('.signature-spa-options').find('.selected').removeClass('selected');
		$('.signature-spa-options .tab-pane.active img').first().addClass('selected'); 

		// find the first image of the active tab pane, check the data-attribute and use that url to populate the background image
		var starting_spa_img_src = $('.signature-spa-options .tab-pane.active img').first().attr('data-large-image-url');
		$('#spa-display-img').css("background-image", "url(" + starting_spa_img_src + ")");

		// find the first image of the active tab pane, check the alt attribute (title) and use that to populate the title with id of #spa-type-title
		var starting_filename = $('.signature-spa-options .tab-pane.active img').first().attr('alt');
		$('.tab-pane.active #spa-type-title').html(starting_filename);
		//console.log(starting_filename);                
    });

    /**
     * Configurator Build Button 
     * Makes sure appropriate product is displayed when clicking the "Build Your..." jump link
     */

    $('.product-jump-link').on("click", function(e) {
    	var target = "tab-" + $(this).data('tab-target');
    	console.log('target: '+target);
    	$('a#'+target).trigger("click");
    });


    /**
     * MPool configurator select boxes functionality
     */
    // setup the initial main image 
    var mpool_img_src = $('#design-container-1 option:selected').data('model-img');
    $('#mpool-display-img').css("background-image", "url(" + mpool_img_src + ")");
    //console.log(mpool_img_src);

    // setup the initial icon image
    var mpool_icon_src = $('#design-container-1 option:selected').data('model-icon');
    $('#mpool-icon-image').attr('src', mpool_icon_src);   
    //console.log(mpool_icon_src);

    // setup the initial pool type title
    var mpool_length = $('#length-select option:selected').data('model-length');
    var mpool_name = $('#design-container-1 option:selected').data('model-name');    
    $('#mpool-type-title').html(mpool_length + "' " + mpool_name);   
    //console.log(mpool_length + mpool_name);
    
    // make sure only mpool length options are showing    
    $('#length-select option[data-model-type="mpool"]').addClass('d-block').removeClass('d-none');      
    $('#length-select option[data-model-type="mpool-infinity"]').addClass('d-none').removeClass('d-block');

    // show the first design drop down container
    $('#design-container-1').removeClass('d-none').addClass('d-block');


    // check the value of the model-type select and show/hide options accordingly
    $('#model-type-select').on('change', function(){
      var selected_model_type = $(this).val();
      //console.log(selected_model_type);
      if ( selected_model_type == 'mpool' ) {
        $('#length-select option[data-model-type="mpool"]').addClass('d-block').removeClass('d-none');      
        $('#length-select option[data-model-type="mpool-infinity"]').addClass('d-none').removeClass('d-block');
      } else if ( selected_model_type == 'mpool-infinity' ) {
        $('#length-select option[data-model-type="mpool"]').addClass('d-none').removeClass('d-block');      
        $('#length-select option[data-model-type="mpool-infinity"]').addClass('d-block').removeClass('d-none');
      }

      $('#length-select option.d-block:first').prop('selected', true);

      var model_title = $('#length-select option.d-block:first').data('model-name');     
      $('.mpool-options h5').html(model_title);
      //console.log(model_title);

      $('.design-select-container.d-block option:first').prop('selected', true);
      $('.design-select-container').removeClass('d-block').addClass('d-none');
      var model_number = $('#length-select option.d-block:first').data('model-number');
      $('#design-container-' + model_number).removeClass('d-none').addClass('d-block');
      //console.log(model_number);

      var mpool_img_src = $('#design-container-' + model_number + ' option:first').data('model-img');
      $('#mpool-display-img').css("background-image", "url(" + mpool_img_src + ")");
      //console.log('#design-container-' + model_number + ' option:first');
      //console.log(mpool_img_src);      

      var mpool_length = $('#length-select option:selected').data('model-length');
      var mpool_name = $('.design-select-container.d-block option:selected').data('model-name');    
      $('#mpool-type-title').html(mpool_length + "' " + mpool_name);   
      //console.log(mpool_length + mpool_name);

      var mpool_icon_img_src = $('.design-select-container.d-block option:selected').data('model-icon');
      $('#mpool-icon-image').attr('src', mpool_icon_img_src);      
      //console.log(mpool_icon_img_src);

    });

    $('#length-select').on('change', function(){
      //$('#mpool-icon-image').attr('src', img_src);
      //$('#mpool-type-title').html(s_title);

      var model_title = $('#length-select option:selected').data('model-name');     
      $('.mpool-options h5').html(model_title);
      //console.log(model_title);

      $('.design-select-container.d-block option:first').prop('selected', true);
      $('.design-select-container').removeClass('d-block').addClass('d-none');
      var model_number = $('#length-select option:selected').data('model-number');
      $('#design-container-' + model_number).removeClass('d-none').addClass('d-block');
      //console.log(model_number);

      var mpool_img_src = $('.design-select-container.d-block option:selected').data('model-img');
      $('#mpool-display-img').css("background-image", "url(" + mpool_img_src + ")");
      //console.log(mpool_img_src);      

      var mpool_length = $('#length-select option:selected').data('model-length');
      var mpool_name = $('.design-select-container.d-block option:selected').data('model-name');    
      $('#mpool-type-title').html(mpool_length + "' " + mpool_name);   
      //console.log(mpool_length + mpool_name);

      var mpool_icon_img_src = $('.design-select-container.d-block option:selected').data('model-icon');
      $('#mpool-icon-image').attr('src', mpool_icon_img_src);      
      //console.log(mpool_icon_img_src);
        
    }); 

    $('[id*="design-container-"]').on('change', function(){
      var mpool_design_img_src = $('option:selected',this).data('model-img');
      $('#mpool-display-img').css("background-image", "url(" + mpool_design_img_src + ")");
      //console.log(mpool_design_img_src);               

      var mpool_length = $('#length-select option:selected').data('model-length');
      var mpool_name = $('option:selected',this).data('model-name');    
      $('#mpool-type-title').html(mpool_length + "' " + mpool_name);   
      //console.log(mpool_length + mpool_name);

      var mpool_icon_img_src = $('option:selected',this).data('model-icon');
      $('#mpool-icon-image').attr('src', mpool_icon_img_src);      
      //console.log(mpool_icon_img_src);       
    });         


    /**
     * Setup classes for home block accordion bg-color
     */
    $('.product-accordion-group').on('show.bs.collapse', function () {
        $(this).addClass('click');      
    });
    $('.product-accordion-group').on('hide.bs.collapse', function () {
        $(this).removeClass('click');
    });    


    /**
     * Set cookie for site notification dismissal
     */
    if ($.cookie('site_note_close') != 'true') {
      $('.site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' }); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
    };     
  
  
    /**
     * Default Slick Slider Example
     */
    $('.slick-slideshow').slick({
      dots: true,
      arrows: false,
      appendDots: '.featured-image-container',
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    });


    /**
     * Create a "clickable" class which makes entire container clickable
     */
    $('.clickable').click(function() {
        window.location = $(this).find('a').attr('href'); 
        return false;
    });


    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */
    // first check if the window location contains a hash, then set it to top straight away
    if (window.location.hash) scroll(0,0);
    // void some browsers issue
    setTimeout( function() { scroll(0,0); }, 1);

    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
        $('a[href*=\\#]:not([href=\\#])').on('click', function() {
            if (!$(this).parents('ul').hasClass('nav-tabs')) {
                var target = $(this.hash);
                // if target.length is 0, set target equal to the name attribuite with hash as value
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // smooth scroll to the target id
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if (window.location.hash.indexOf('gf') == 1) { 
      } else {

        if(window.location.hash) {
            var target = $(window.location.hash);
            // if target.length is 0, set target equal to the name attribuite with hash as value
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            // smooth scroll to the target id
            $('html, body').delay(1000).animate({
              scrollTop: $(target).offset().top + 'px'
            }, 1000);
            return false;
        }
      }

    });

    
    
/*** KYRO ***/
    
    
$('.kyro-1-gallery').slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
 });
    
$('.kyro-2-gallery').slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
 });
$('.accordian-item').each(function() {
    if($(this).hasClass('active')){
        $(this).find('.accordian-item-content').show();
    }else{
        $(this).find('.accordian-item-content').hide();
    }
    
    $(this).find('.accordian-item-title a').on('click', function(e){
    e.preventDefault();
        var this_accordian_item = $(this).parent().parent();
        if(this_accordian_item.hasClass('active')){
            this_accordian_item.find('.accordian-item-content').slideUp(200, function(){
                this_accordian_item.removeClass('active');
            });
        }else{
            this_accordian_item.find('.accordian-item-content').slideDown(300, function(){
             this_accordian_item.addClass('active');
            });
            
        }
        
    });
    
});

    
$('.tabbed-header a.tab-trigger').each(function() {
    var this_tab = $(this).data('tab-group');
   
    if($(this).hasClass('active-tab')){
        //alert('active')
        $('#' + this_tab).show().addClass('active-tab');
    }else{
        //alert('hidden');
        $('#' + this_tab).hide();
    }
    
    $(this).on('click', function(e){
    e.preventDefault(); 
        var this_tab_triggered = $(this).data('tab-group');
        if($(this).hasClass('active-tab')){
           //alert('active');
        }else{
            $('.tabbed-header a.tab-trigger').removeClass('active-tab');
            $(this).addClass('active-tab')
            $('.tab-group').hide().removeClass('active-tab');
            $('#' + this_tab_triggered).slideDown(300, function(){
             $('#' + this_tab_triggered).addClass('active-tab');
            });
            //alert('not-active');
        }
    });
}); 
    
} );
